<script>
import DocumentListComponent from "./components/resources/DocumentListComponent.vue";
import AutoriryComponent from "./components/resources/AutoriryComponent.vue";
import NewsComponent from "./components/resources/NewsComponent.vue";
import ITCGridComponent from "./components/resources/ITCGridComponent.vue";
import BoxIconGridComponent from "./components/resources/BoxIconGridComponent.vue";
import MultiSliderComponent from "./components/resources/MultiSliderComponent.vue";
// import FrecuentAccessComponent from "./components/resources/FrecuentAccessComponent.vue";
// import GridLinkComponent from "./components/resources/GridLinkComponent.vue";
// import CentroDeSaludComponent from "./components/resources/CentroDeSaludComponent.vue";
import CardGridComponent from "./components/resources/CardGridComponent.vue";
import InfoCidiComponent from "./components/resources/InfoCidiComponent.vue";
import VideoContainerComponent from "./components/resources/VideoContainerComponent.vue";

export default {
  name: "HomeView",
  components: {
    DocumentListComponent,
    AutoriryComponent,
    NewsComponent,
    ITCGridComponent,
    BoxIconGridComponent,
    MultiSliderComponent,
    // FrecuentAccessComponent,
    // GridLinkComponent,
    // CentroDeSaludComponent,
    CardGridComponent,
    InfoCidiComponent,
    VideoContainerComponent,
  },
  data() {
    return {
      site: 11,
    };
  },
  methods: {
    openBotArchivo() {
      const botmaker = window.botmaker.iframe.contentWindow;
      botmaker.bmSendMessage("CANME", { text: "CANME" });
      botmaker.bmMaximize();
    },
    handleComponentAction(actionName) {
      if (this[actionName] && typeof this[actionName] === 'function') {
        this[actionName]();
      }
    },
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
  },
};
</script>

<template>

  <!-- seccion info -->
  <div class="multi-slider">
    <MultiSliderComponent titulo="" :elementos="1" :mostrar-titulo="false" :mostrar-bordes="false" :ajustar="true"
      :data="[
        {
          desc: null,
          imagen: require('@/assets/img/comitedeinvestigacion.jpg'),
          target: '_blank',
          url: 'https://salud.sanjuan.gob.ar/etica/',
          ajustado: true,
          extendido: true,
        },
        {
          desc: null,
          imagen: require('@/assets/img/registro-profesionales-salud-desktop.png'),
          target: '_self',
          title: 'Solicitud de Matrícula Profesional',
          url: 'https://profesionalsalud.sanjuan.gob.ar/',
        },
        {
          desc: null,
          imagen: require('@/assets/img/26.Web1121x168_0626-mobile.jpg'),
          target: 'self',
          url: '',
        },
        {
          desc: null,
          imagen: require('@/assets/img/manipulacion-de-alimentos.png'),
          target: '_self',
          url: 'https://forms.gle/9HGKTd3jrVpWQEe58',
        },
        {
          desc: null,
          imagen: require('@/assets/img/Banner_pdfs.png'),
          target: 'self',
          url: '?uid=informacionGeneral',
        },
      ]" />
  </div>

  <div class="multi-slider-mobile">
    <MultiSliderComponent forma="cuadrada" titulo="" :elementos="1" :mostrar-titulo="false" :mostrar-bordes="false"
      :ajustar="true" :data="[
        {
          desc: null,
          imagen: require('@/assets/img/comitedeinvestigacioncel.jpg'),
          target: '_blank',
          url: 'https://salud.sanjuan.gob.ar/etica/',
          ajustado: true,
          extendido: true,
        },
        {
          desc: null,
          imagen: require('@/assets/img/registro-profesionales-salud-mobile.png'),
          target: '_self',
          title: 'Solicitud de Matrícula Profesional',
          url: 'https://profesionalsalud.sanjuan.gob.ar/',
        },
        {
          desc: null,
          imagen: require('@/assets/img/26.Web16x16_0626-desk.jpg'),
          target: 'self',
          url: '',
        },
        {
          desc: null,
          imagen: require('@/assets/img/manipulacion-de-alimentos-mobile.jpeg'),
          target: '_self',
          url: 'https://forms.gle/9HGKTd3jrVpWQEe58',
        },
        {
          desc: null,
          imagen: require('@/assets/img/Banner_pdf_mobile.jpg'),
          target: 'self',
          url: '?uid=informacionGeneral',
        },
      ]" />
  </div>

  <InfoCidiComponent />

  <VideoContainerComponent />

  <ITCGridComponent :columnas="4" :data="[
    /*  {
    
      desc:null,
      icon:'chat',
      target:'_self',
      title:'Información Institucional',
      url:''
    },
    {
      desc:null,
      icon:'speaker_notes',
      target:'_self',
      title:'Planes y Programas',
      url:''
    }, */
    {
      desc: null,
      icon: 'ptn-i-salud',
      target: '_self',
      title: 'Centros de Salud',
      url: '?uid=CUMV-VIEW-CentrosDeSalud'
    },
    {
      desc: null,
      icon: 'question_answer',
      target: '_self',
      title: 'Consulta de Expedientes',
      url: '?uid=CUMV-VIEW-ExpedientesComponent',
    },
    {
      desc: null,
      icon: 'question_answer',
      target: '_self',
      title: 'Consultas y Solicitudes',
      url: 'https://tramite.sanjuan.gob.ar/tramite/org/30',
    },
    {
      desc: null,
      icon: 'bloodtype',
      target: '_self',
      title: 'Turnos Donación de Sangre',
      url: 'https://darturnos.com/iphem',
    },
  ]" />

  <section>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 class="text-ptn-color-gsj-brand">Misión:</h3>
          <p class="pb-3">
            Asegurar el Derecho a la Salud mediante la planificación, coordinación, regulación y gestión de políticas y
            estrategias sanitarias, contribuyendo al desarrollo pleno y sano de la población, identificando los factores
            que producen inequidad en el acceso a los servicios de salud, y ayudando a mejorar las condiciones de salud
            mediante la generación de conocimientos del proceso salud enfermedad y determinantes asociados, de modo que
            los mismos sean un material de referencia para los decisores en Salud y el resultado se traduzca en un
            beneficio directo para los Sanjuaninos.
          </p>
          <h3 class="text-ptn-color-gsj-brand">Visión:</h3>
          <p>
            Gestionar la Salud, de un modo eficiente, transparente, humanizado, que garantice el acceso de la población
            de manera universal y equitativa, interviniendo sobre los determinantes de la salud y la prevención de
            enfermedades, en coordinación con otros sectores públicos y privados fomentando la participación activa de
            las personas.
          </p>
          <h3 class="text-ptn-color-gsj-brand">
            Valores:
          </h3>
          <div>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Universalidad: Es la responsabilidad delestado a garantizar a toda la población,bajo un enfoque de
              derecho, el acceso al sistema de salud con calidad, sin límites geográficos, sociales, económicos y
              culturales.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Equidad: Es la justa distribución de las posibilidades y oportunidades de acceso a la información,
              conocimientos, recursos, bienes y servicios, para promover, mejorar y mantener la salud individual y
              colectiva, dando más a quien más necesita. En este sentido se busca disminuir las diferencias en la
              atención de la salud de la población, por cuanto son innecesarias, evitables, incorrectas e injustas.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Integralidad: Entiende al ser humano como un ser biopsicosocial, entramado en la familia, en la cultura,
              en su historia individual y social, donde la salud se constituye como un proceso dinámico donde la persona
              como “ser activo” posee la capacidad permanente de modificar los aspectos y las condiciones que
              obstaculizan el desarrollo de una vida plena con mayor bienestar.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Calidad: Es la capacidad del sistema de salud para ofrecer atención integral que solucione
              satisfactoriamente las necesidades de las personas y grupos sociales, ofreciéndoles los mayores beneficios
              y evitando riesgos.
            </p>
            <p class="fac-a">
              <span class="material-symbols-outlined fac-span text-ptn-color-gsj-brand iconos">done_outline</span>
              Inclusión Social: Es la condición en la que se reconocen los derechos, deberes, igualdades y equidades a
              las personas y grupos sociales en situación de desventaja y vulnerabilidad, sin distinción de género,
              etnia o ideología. Una persona o grupo social incluido, significa que está integrado social e
              institucionalmente en las redes creadas por la sociedad, abarcando las dimensiones: política, económica,
              social y cultural.
            <ul>
              <li>Atención primaria de la salud (APS)</li>
              <li>Capacitación continua del recurso humano de salud</li>
              <li>Valorización de recurso humano</li>
              <li>Articulación intersectorial y participación comunitaria</li>
              <li>Fortalecimiento de Redes Integrales del Servicio de Salud</li>
              <li>Cultura de la información y la comunicación</li>
              <li>Informatización y tecnología apropiada</li>
              <li>Infraestructura adecuada</li>
            </ul>
            De esta forma el PES tendrá como estrategia la atención primaria de la salud (APS.). Para ello
            profundizaremos las acciones tendientes a la capacitación continua del recurso humano de salud tanto en el
            modo de gestión, como en la calidad de la atención, mejora continua, de tal manera que se sientan
            valorizados, no solo con su remuneración, sino como personas, para que sientan y entiendan que desde su
            lugar de trabajo están prestando un servicio hacia la gente que lo necesita. Teniendo en cuenta que la
            comunidad debe participar activamente en el cuidado y mantenimiento de su salud, por lo que trabajaremos en
            intensas campañas de educación para la salud, para que cada uno desde su lugar en la sociedad, actúe como
            agente multiplicador de las acciones preventivas necesarias para lograr el bienestar físico y social de cada
            individuo.
            </p>

          </div>
        </div>
      </div>
    </div>
  </section>

  <NewsComponent titulo="Noticias" />

  <CardGridComponent columnas="1" :data="[
    {
      target: '_self',
      title: 'Licitaciones',
      url: 'https://licitaciones.sanjuan.gob.ar/',
    },
  ]" />

  <DocumentListComponent titulo="Residencias de Salud" :show-fecha="true" resultados="10" :staticItems="[
    { id: 36, Nombre: 'Programas de Formación de Residencias', Fecha_Publicacion: '2025-02-18', seccion: 'residencias' },
    { id: 34, Nombre: 'Residencias del Equipo de Salud - Información General', Fecha_Publicacion: '2024-09-24', seccion: 'residencias' },
    { id: 57, Nombre: 'Bibliografía examen Residencias San Juan 2026', Fecha_Publicacion: '2026-02-13', seccion: 'residencias' },
    { id: 39, Nombre: 'CRONOGRAMA CONCURSO RESIDENCIAS EN SALUD 2026', Fecha_Publicacion: '2025-02-27', seccion: 'residencias' },
    { id: 101, Nombre: 'Especialidades y cupos 2026', Fecha_Publicacion: '2026-03-11', seccion: 'residencias' },
    { id: 102, Nombre: 'PADRÓN DEFINITIVO DE HABILITADOS PARA RENDIR', Fecha_Publicacion: '2026-04-14', seccion: 'residencias' },
    { id: 103, Nombre: 'Examen Ingreso a Residencias 2026 - 28 de Mayo de 2026', Fecha_Publicacion: '2026-05-11', seccion: 'residencias' },
    { id: 104, Nombre: 'Cronograma de Entrevistas para Postulantes - Concurso 2026', Fecha_Publicacion: '2026-05-15', seccion: 'residencias' },
    { id: 105, Nombre: 'Exámenes y grillas de corrección de Residencias en Salud - Concurso 2026', Fecha_Publicacion: '2026-07-03', seccion: 'residencias' },
    { id: 106, Nombre: 'Notas de Examen de Ingreso a las Residencias en Salud', Fecha_Publicacion: '2026-07-13', seccion: 'residencias' },
    { id: 107, Nombre: 'Respuestas a la instancia de apelaciones', Fecha_Publicacion: '2026-07-17', seccion: 'residencias' },
    { id: 108, Nombre: 'Orden de Mérito Definitivo', Fecha_Publicacion: '2026-07-21', seccion: 'residencias' },
    { id: 109, Nombre: 'FE DE ERRATAS DE ORDEN DE MÉRITO RISAMC', Fecha_Publicacion: '2026-07-21', seccion: 'residencias' },
    { id: 110, Nombre: 'ACTO DE ADJUDICACIÓN DE BECAS DE RESIDENCIAS 2026', Fecha_Publicacion: '2026-07-31', seccion: 'residencias' },
    { id: 111, Nombre: 'Curso Obligatorio en Control de Infecciones y Uso Apropiado de Recursos', Fecha_Publicacion: '2026-08-12', seccion: 'residencias' },
    { id: 112, Nombre: 'INSTANCIA DE PRIMERA READJUDICACIÓN DE BECAS VACANTES', Fecha_Publicacion: '2026-09-08', seccion: 'residencias' },
    { id: 113, Nombre: 'ORDEN DE MÉRITO 1° READJUDICACIÓN', Fecha_Publicacion: '2026-09-17', seccion: 'residencias' },
    { id: 115, Nombre: 'ORDEN DE MÉRITO 2° READJUDICACIÓN', Fecha_Publicacion: '2026-10-23', seccion: 'residencias' },
    { id: 114, Nombre: 'INSTANCIA DE SEGUNDA READJUDICACIÓN DE BECAS VACANTES', Fecha_Publicacion: '2026-10-06', seccion: 'residencias' }
  ]" />

  <BoxIconGridComponent titulo="Accesos Útiles" @action="handleComponentAction" :data="[
    {
      desc: null,
      icon: 'ptn-i-salud',
      target: '_self',
      title: 'Registro de Profesionales de Salud',
      url: 'https://profesionalsalud.sanjuan.gob.ar/',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Requisitos de habilitación piscinas',
      url: 'https://salud.sanjuan.gob.ar/docs/Requisitos_de_habilitacion_piscinas.pdf',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Requisitos habilitación salones infantiles',
      url: 'https://salud.sanjuan.gob.ar/docs/Requisitos_habilitacion_salones_infantiles.pdf',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Video - Carga de Cumplimiento Fiscal',
      url: 'https://www.youtube.com/watch?v=9TZi6DUfvEs&ab_channel=MinisteriodeSaludP%C3%BAblicaSanJuan',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Solicitud de Carta Médica',
      url: 'https://gedoc.sanjuan.gov.ar/dcrm/',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Incluir Salud',
      url: 'https://www.argentina.gob.ar/andis/acceder-al-programa-federal-incluir-salud',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_blank',
      title: 'Dirección de Materno Infancia',
      showDropdown: true,
      links: [
        { text: 'Octubre Rosa', url: 'https://salud.sanjuan.gob.ar/docs/251019_Cancer de mama.pdf' },
        { text: 'Lineamientos de calidad para el abordaje de la salud integral para adolescentes', url: 'https://salud.sanjuan.gob.ar/docs/Dosier Lineamientos.pdf' },
        { text: 'Ruta de Abordaje en adolescentes embarazadas menores de 16 años.', url: 'https://salud.sanjuan.gob.ar/docs/Dosier Liniamentos Adolescentes (2).pdf' },
        { text: 'Control integral de salud de niñas, niños y adolescentes', url: 'https://contenidodirecto.sanjuan.gob.ar/assets/9eb3b470-0d66-4ccc-9111-92157701f1d1' },
        { text: 'Cáncer de mama', url: 'https://salud.sanjuan.gob.ar/docs/Cancer_mama.pdf' },
        { text: 'Interrupción del embarazo en el sistema de salud', url: 'https://salud.sanjuan.gob.ar/docs/Manual Ive-1_250210_095555.pdf' },
        { text: 'Hipertensión en el embarazo', url: 'https://salud.sanjuan.gob.ar/docs/Dosier Hipertensión en el embarazo.pdf' },

      ]
    },
    // {
    //   desc: null,
    //   icon: 'ptn-i-documento',
    //   target: '_blank',
    //   title: 'Protocolo de Farmacia',
    //   url: 'https://sanjuan.gob.ar/docs/minsalud/NORMA_PROVINCIAL_FUNCIONAMIENTO_CENTRALES_ESTERILIZACION%20PDF.pdf',
    // },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_blank',
      title: 'Material sobre Dengue para Equipos de Salud',
      url: '/docs/guia_manejo_dengue.pdf',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Fichas Epidemiológicas',
      url: '?uid=FichasEpidemiologicas',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_self',
      title: 'Boletines Epidemiológicos',
      url: '?uid=boletinesEpidemiologicos',
    },
    {
      desc: null,
      icon: 'chat',
      action: 'openBotArchivo',
      title: 'CANME',
    },
    {
      desc: null,
      icon: 'ptn-i-documento',
      target: '_blank',
      title: 'PROSADIA',
      showDropdown: true,
      links: [
        { text: 'Manual Diabetes Gestacional', url: 'https://salud.sanjuan.gob.ar/docs/Manual_Diabetes_Gestacional.26_Web-2.pdf' },

      ]
    },
  ]" />

  <AutoriryComponent :showProtocolo="false" :showLinks="true" :data="[
    {
      title: 'Amilcar Dobladez',
      subtitle: 'Ministro de Salud',
      imagen: require('@/assets/img/mindesalud.jpg'),
    },
  ]" />

  <!--
  <FrecuentAccessComponent />
  <GridLinkComponent />
  <CentroDeSaludComponent />
  -->
</template>

<style scoped>
.multi-slider-mobile {
  display: none;
}

/*
  El slider cuadrado (.multi-slider-mobile) debe alinearse con el breakpoint
  interno de MultiSliderComponent, que recien pasa a slideRatio 1 (cuadrado) en
  max-width:600px. Si lo mostramos antes (ej. a 993px), el componente todavia
  usa su aspectRatio 1/6 y la imagen cuadrada se ve diminuta/aplastada. Por eso
  recortamos en 600px: arriba de eso va el slider ancho (1121x168) que si encaja
  en ese ratio.
*/
@media (max-width: 600px) {
  .multi-slider {
    display: none;
  }

  .multi-slider-mobile {
    display: block;
  }
}

.multi-slider :deep(.vueperslide),
.multi-slider-mobile :deep(.vueperslide),
.multi-slider :deep(.vueperslides__parallax-wrapper),
.multi-slider-mobile :deep(.vueperslides__parallax-wrapper),
.multi-slider :deep(.vueperslide__content-wrapper),
.multi-slider-mobile :deep(.vueperslide__content-wrapper) {
  height: 100% !important;
  width: 100% !important;
}

.multi-slider :deep(.vueperslide__image),
.multi-slider-mobile :deep(.vueperslide__image) {
  background-size: cover !important;
  background-position: center center !important;
  background-repeat: no-repeat !important;
  width: 100% !important;
  height: 100% !important;
}
</style>
